import { render, staticRenderFns } from "./BusinessObjDialog.vue?vue&type=template&id=4b10d7ff&scoped=true&"
import script from "./BusinessObjDialog.vue?vue&type=script&lang=js&"
export * from "./BusinessObjDialog.vue?vue&type=script&lang=js&"
import style0 from "./BusinessObjDialog.vue?vue&type=style&index=0&id=4b10d7ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b10d7ff",
  null
  
)

export default component.exports